export default {
  courseLevelCount: 'Course Levels / Sessions',
  errorAnalysisRequireLabel: 'Error Analysis Requirement',
  learnErrorCount: 'Incorrect Problems (Learning)',
  markedErrorCount: 'Marked Incorrect Problems',
  errorMarkRate: 'Error Tagging Rate',
  totalQuestionCount: 'Total Problems',
  readCircleCount: 'Annotated Problems',
  readCircleRate: 'Coverage Rate',
  readCircleRightRate: 'Accuracy (Annotated Problems)',
  noReadCircleRightRate: 'Accuracy (Non-Annotated Problems)',
  invalidReadCircleCount: 'Invalid Annotations',
  validReadCircleRate: 'Valid Annotation Rate',
  chapterTaskCard: 'Chapter Task Card',
  account: 'Account',
  accountBalance: 'Account Balance',
  accountDisabledTip: 'This account has been disabled due to [{reason}] and cannot be re-enabled. Disabled by: [{source}]. For questions, please contact the responsible party.',
  accountModifyRecord: 'Account Change History',
  /** Account edit log: opDescCode / opTypeCode — same codes as backend enum */
  accountEditOpCode: {
    6155001: 'Create',
    6155002: 'Activate',
    6155003: 'Upgrade',
    6155004: 'Unbind mobile number',
    6155005: 'Unbind DingTalk',
    6155006: 'Change bound mobile number',
    6155007: 'Change DingTalk binding',
    6155008: 'Add mobile binding',
    6155009: 'Add DingTalk binding',
    6155010: 'Leave headquarters',
    6155011: 'Disable',
    6155012: 'Enable',
    6155013: 'Freeze',
    6155014: 'Unfreeze',
    6155015: 'Offboarding',
    6155016: 'Edit',
    6155017: 'Support assisted'
  },
  accountPassword: 'Password',
  accountRoleName: 'Account Role',
  accountSearch: 'Account Search',
  accountSecurityTip: 'For security purposes, please enter your password.',
  accountSet: 'Account Management',
  accountStatus: 'Account Status',
  accountStatusLabel: 'Account Status',
  accountStatusPlaceholder: 'Account Status',
  accountTypeLabel: 'Account Type',
  accumulatedAbnormal: 'Total Exceptions',
  activateMonth: 'Software Activation Month',
  activateStatus: 'Software Activation Status',
  activateTime: 'Software Activation Time',
  active: 'Active',
  add: 'Add',
  addAccount: 'Add Account',
  addAccountFailed: 'Failed to add account',
  addAccountSuccess: 'Account added successfully',
  addAccountSuccessMsg: 'Account added successfully',
  addAction: 'Add',
  addAnalyst: 'Add Analyst',
  addCustomRole: 'Add Custom Role',
  addEmployee: 'Add Employee',
  addEmployeeTip: 'After adding an employee account, the employee will receive a DingTalk invitation and can join by logging in.',
  addFaceInfo: 'Add Facial Recognition Data',
  addFailed: 'Failed to add',
  addInfoSuccess: 'Information added successfully',
  addSchoolFail: 'Failed to add school',
  addSchoolSuccess: 'School added successfully',
  addStudent: 'Add Student',
  addStudentArchiveTip: '(Note: Users with incomplete profiles are excluded. Please complete the profile first.)',
  addSuccess: 'Added successfully',
  agent: 'Master Franchisee ID',
  agentId: 'Master Franchisee ID',
  agentLabel: 'Master Franchisee',
  agentName: 'Master Franchisee Name',
  agentNo: 'Agent Seat ID',
  agentNoLabel: 'Agent Seat ID:',
  agentNoPlaceholder: 'Agent Seat ID',
  agentTypeLabel: 'Master Franchisee Type',
  all: 'All',
  already: 'Used Quota',
  amount: 'Redeemed Voucher Amount',
  analysisSystemAccountStatus: 'Analytics System Account Status',
  analyst: 'Analyst:',
  analystAccountStatus: 'Analyst Account Status',
  analystAddStudents: 'Analyst {name} added students',
  analystName: 'Analyst Name',
  analystNamePlaceholder: 'Analyst Name / Phone Number',
  answerFast: 'Answered Too Quickly',
  answerSlow: 'Answered Too Slowly',
  applyAccount: 'Apply for Account',
  applyAccountQuotaTip: '{action} quota: {count}',
  experienceApplyConfirmTip: 'Once submitted, {name} will receive an employee learning account. Please ensure proper usage. Confirm to proceed?',
  applyAnalystConfirm: 'Confirm assigning Analyst role to the selected employee(s)?',
  applyAnalystRole: 'Apply for Analyst Role',
  applyAnalystTitle: 'Apply for Analyst Access',
  applying: 'Pending Application',
  approved: 'Approved',
  asset: 'Assets',
  assignPermissions: 'Assign Permissions',
  audioParseError: 'Audio parsing failed. Please upload again.',
  audit: 'Review Comments',
  authorityDetails: 'Permission Settings',
  autumnTerm: 'Fall Term',
  back: 'Back',
  bai: 'Hundreds Place',
  batchAddFailed: 'Batch add failed',
  batchAddStudent: 'Batch add students',
  batchAddSuccess: 'Batch add successful',
  batchCancelAssignFail: 'Batch unassign failed',
  batchCancelAssignSuccess: 'Batch unassign successful',
  batchRemoveFailed: 'Batch removal failed',
  batchRemoveStudent: 'Batch remove students',
  batchRemoveSuccess: 'Batch removal successful',
  beforeLastMonthHighActiveRate: 'High Activity Rate (2 Months Ago)',
  bindMobile: 'Bind Phone Number',
  bindMobileSuccess: 'Phone number bound successfully',
  bonusGranted: 'Bonus Issued',
  buyNum: 'Purchase Quantity',
  callSystem: 'Call System',
  callTime: 'Call Time',
  cancel: 'Cancel',
  cancelInvite: 'Cancel Invitation',
  channelAgentName: 'Channel Master Franchisee Name',
  checkAddTip: 'Please select students to add',
  checkRemoveTip: 'Please select students to remove',
  chineseBaseDuration: 'Chinese Foundation Total Duration',
  chineseBaseProgress: 'Chinese Foundation Max Progress',
  chuangjian: 'Created By',
  ci: 'Count',
  city: 'City',
  claimInternalAccount: 'Claim Internal Trial Account',
  claimTime: 'Claim Time',
  claimUser: 'Claimed By',
  clearFilter: 'Clear Filters',
  clickToSelect: 'Click to Select',
  collapse: 'Collapse',
  completePaymentTime: 'Payment Completion Time',
  completed: 'Completed',
  completionStatus: 'Completion Status',
  confirm: 'Confirm',
  confirmAndConfigPermission: 'Confirm and Configure Permissions',
  confirmDeleteCustomIdentity: 'Are you sure you want to delete this custom role?',
  confirmResetPassword: 'Are you sure you want to reset the password?',
  consecutiveError: 'Consecutive Errors',
  contractPaidAmount: 'Contract Payment Amount',
  copy: 'Copy',
  copySuccess: 'Copied successfully',
  course: 'Course',
  courseLevelTimes: 'Course Levels / Sessions',
  createSuccess: 'Created successfully',
  createTime: 'Created Time',
  createTimeLabel: 'Created Time',
  currentSupervisor: 'Current Instructor',
  customIdentityDesc: 'Custom Role Description:',
  customIdentityName: 'Custom Role Name:',
  customRole: 'Custom Role',
  customer: 'Select referral customer ID',
  customerName: 'Customer Name / Phone',
  customerPhone: 'Customer Phone',
  customerArea: 'Customer Region',
  dai: 'Channel Master Franchisee ID',
  daiji: 'Cumulative Channel Master Franchisee Level',
  dailyActivationTime: 'Average Daily Activation Time',
  dailyUpdateTip: 'Data is updated daily with the previous day’s data. Weekly data is finalized every Monday.',
  dataAnalysisPassword: 'Data Analysis System Password',
  dataAnalysisSystem: 'Large Model Data Analysis System',
  dataAnalysisUsername: 'Data Analysis System Username',
  dataPermissionConfig: 'Data Permission Configuration',
  dataPermissionDesc: 'Defines what data employees can access',
  dataUpdateTime: 'Data Update Time:',
  dataUpdatedTo: 'Data Updated To:',
  date: 'Date',
  dateLabel: 'Date',
  dateRangeTo: 'to',
  day: 'Full-Time',
  dayci: 'Daily Consecutive Errors',
  dayhour: 'Daily Idle or Exit Duration Ratio',
  daze: 'Idle Time',
  dealer: 'Franchisee Referral Renewal Reward Rate',
  dealerPassword: 'Franchisee System / Mini Program Password',
  dealerSystem: 'Franchisee System',
  dealerSystemOnly: 'Franchisee System Only',
  dealerSystemPlusAnalysis: 'Franchisee System + Analytics System',
  dealerSystemTip: 'To use the franchisee mini program, please select "Franchisee System" first',
  dealerUsername: 'Franchisee System / Mini Program Username',
  delete: 'Delete',
  deleteCustomIdentityTip: 'Deleting this will not affect employees who previously used this custom role for permissions.',
  deleteFailed: 'Delete failed',
  deleteInfoSuccess: 'Information deleted successfully',
  deleteRole: 'Delete Role',
  deleteSuccess: 'Deleted successfully',
  deliverOrderValueExport: 'Delivery Order Value Report Export',
  desc: 'Description',
  detail: 'Details',
  deviceStatusActivated: 'Activated',
  deviceStatusFrozen: 'Frozen',
  deviceStatusLabel: 'Device Status',
  deviceStatusSubscribed: 'Subscribed',
  deviceStatusUnactivated: 'Not Activated',
  deviceUseStatus: 'Device Usage Status',
  deviceUseTime: 'Device Usage Time',
  dianhua: 'Referrer Phone',
  difficultyExplain: 'Ability to Explain Difficulty Levels',
  dimension: 'Dimension',
  dimensionHighActive: 'High Activity',
  dimensionRetention: '3-Month Retention Rate',
  dimensionStudyAbnormal: 'Abnormal Learning Behavior',
  dimensionStudyDuration: 'Study Duration',
  dimensionStudyTrace: 'Learning Trace',
  disNo: 'Outbound Caller ID',
  disNoPlaceholder: 'Outbound Caller ID',
  disable: 'Disable',
  disableAccountConfirmTip: 'After disabling, {username} (linked to {phone}) will not be able to access {systemName}. Are you sure you want to proceed?',
  /** Disable confirm: backend systemType 2 / 3; type 1 uses dealerSystem */
  disableAccountAccessSystemAgent: 'Master Franchisee System',
  disableAccountAccessSystemAnalyst: 'Analyst System',
  disableConfirm: 'Are you sure you want to disable this account?',
  disableSuccess: 'Disabled successfully',
  experienceDisableConfirmTip: 'After disabling, {name}’s learning account will no longer function on the learning tablet. Are you sure you want to proceed?',
  disableTip: 'After disabling, this account cannot log in or use the Franchisee system',
  disabled: 'Disabled',
  dispatchMonth: 'Shipping Month',
  dispatchNum: 'Shipment Quantity',
  dispatchQuantity: 'Shipment Quantity',
  dispatchTime: 'Shipping Time',
  dispatchType: 'Shipping Method',
  district: 'District/County',
  doubleOrder: 'Double Order',
  downloadDetailData: 'Download Detailed Data',
  draftCorrectRate: 'Draft Accuracy Rate',
  draftMarkRateLabel: 'Draft Marking Rate',
  draftPassRateLabel: 'Draft Step Pass Rate',
  draftQualifyHelp: 'How to determine if draft work is qualified?',
  draftRate: 'Sampled Draft Step Pass Rate',
  draftStepPassRate: 'Draft Step Pass Rate',
  draftWriting: 'Draft Work',
  draftWritingRate: 'Draft Step Completion Rate',
  durationMin: 'Duration (min)',
  edit: 'Edit',
  editAccount: 'Edit Account',
  editAccountFailed: 'Edit account failed!',
  editAccountFailedMsg: 'Edit account failed',
  editAccountSuccess: 'Account updated successfully',
  editFailed: 'Edit failed',
  editRole: 'Edit Role',
  editSchoolSuccess: 'School updated successfully',
  editSuccess: 'Updated successfully',
  effectiveDuration: 'Effective Duration',
  effectiveFoundationTime: 'Effective Foundation Learning Time',
  effectiveScoreCollectRate: 'Effective Score Collection Rate',
  effectiveScoreNum: 'Students with Valid Scores',
  effectiveScoreRate: 'Effective Score Rate',
  email: 'Email',
  emailOrMobileRequired: 'Either email or phone number is required',
  invalidEmailFormat: 'Please enter a valid email address',
  employeeAccount: 'Employee Account',
  employeeAccountStatus: 'Employee Account Status',
  employeeName: 'Employee Name:',
  employeeRole: 'Employee Role',
  employeesAccount: 'Employee Accounts',
  enable: 'Enable',
  enableConfirm: 'Are you sure you want to enable this account?',
  enableFailed: 'Enable failed',
  enableSuccess: 'Enabled successfully',
  enableSuccessMsg: 'Enabled successfully',
  enableTip: 'Once enabled, this account can log in and use the Franchisee system normally',
  enabled: 'Enabled',
  englishBaseDuration: 'English Foundation Total Duration',
  englishBaseProgress: 'English Foundation Max Progress',
  entryAccount: 'Starter Account',
  equipmentValueExport: 'Equipment Value Report Export',
  er: 'Level 2',
  errorAnalysis: 'Error Analysis',
  errorAnalysisCompletion: 'Error Analysis Completion',
  evaluationScoreLabel: 'Evaluation Score',
  errorAnalysisHelp: 'How to conduct error analysis?',
  errorAnalysisRequired: 'When students are in Levels 1–6 (first two attempts) of foundation learning, error analysis is required',
  errorAnalyzeLabel: 'Error Analysis Completion Rate',
  errorCount: 'Number of Incorrect Questions',
  examScoreImprovementRate: 'Major Exam Score Improvement Rate',
  examType: 'Exam Type',
  examTypeLabel: 'Major Exam Type',
  exampleTrial: 'Sample Problem',
  exampleTrialNorm: 'Sample Problem Quality',
  exampleTrialRate: 'Sample Problem Rate',
  exampleTrialTraceRate: 'Sample Problem Trace Rate',
  exceptionLevelLabel: 'Level Exception',
  expand: 'Expand',
  experienceAccount: 'Trial Account',
  experienceStudentCount: 'Number of Trial Students Managed',
  experiencesAccount: 'Employee Learning Account',
  exportReport: 'Export Report',
  expressCompany: 'Logistics Company',
  expressNo: 'Tracking Number',
  expressNoLabel: 'Shipment Number',
  faceExistUploadCorrect: 'Face data already exists. Please upload a valid employee photo',
  faceInfoStatus: 'Face Data Status',
  faceVerifyStatusMissing: 'Missing',
  faceVerifyStatusRecorded: 'Recorded',
  faceVerifyStatusNormal: 'Normal',
  faceInfoRiskTip: 'The employee learning account has risk control enabled. A face photo must be uploaded before the account can be used',
  faceInfoMissingPausedTip: 'This employee learning account has not recorded face information and has been suspended. It can be resumed after face information is uploaded.',
  faceInfoUpdatedRecentlyTip: 'Face data was recently updated. Please try again after {time}',
  faceInfoUpdateLimitTip: 'Face data can only be updated once every two months. Last updated at {time}',
  faceInfoAgeConfirm: 'The photo does not appear to be of an adult. Are you sure you want to use this photo?',
  faceInfoUploadFormatTip: 'Only JPG, JPEG, GIF, PNG, and BMP formats are supported',
  facePhotoEncryptTip: '* Your uploaded photo will be encrypted and used only for verification purposes',
  facePhotoSpec: 'Photo Requirements:',
  facePhotoSpec1: 'The photo must be a front-facing image',
  facePhotoSpec2: 'Avoid wearing hats or accessories',
  facePhotoSpec3: 'Use a plain white background',
  female: 'Female',
  fillBasicInfo: 'Please fill in the basic information',
  fillerLabel: 'Completed By',
  finalExam: 'Final Exam',
  finalPaymentTime: 'Final Payment Time',
  firstDispatchTime: 'First Shipment Time',
  firstTime: 'First Time',
  firstWeekFeedback: 'First Week Feedback',
  fixedPositionComponentTip: 'Fixed-position components (e.g., bottom navigation, floating elements) cannot be placed first',
  followLabel: 'Follow-Up:',
  followingUp: 'Following Up',
  formalStudentCount: 'Number of Active Students Managed',
  freightAmount: 'Prepaid Shipping Fee',
  frontFacePhoto: 'Front-Facing Photo',
  frozen: 'Frozen',
  fullProcessTraining: 'End-to-End Training',
  fulltime: 'Full-Time',
  functionPermissionConfig: 'Function Permission Configuration',
  functionPermissionDesc: 'Defines which features employees can access',
  gender: 'Gender',
  getDataFailed: 'Failed to retrieve data',
  getDataFailedExclaim: 'Failed to retrieve data!',
  getVerifyCode: 'Get Verification Code',
  goldCoin: 'Gold Coins',
  goldCoinUnit: 'coins',
  grade: 'Grade Level',
  handover: 'Handover',
  handoverPerson: 'Handover Person',
  handoverRecord: 'Handover Record',
  hantianCallSystem: 'Hantian Call System',
  hardStatus: 'Hardware Activation Status',
  hardTime: 'Hardware Activation Time',
  hardwareActivateTime: 'Hardware Activation Time',
  healthExplain: 'Ability to Explain Performance Levels',
  healthUpDownExplain: 'Performance Level Change Explanation',
  highActive: 'Highly Active',
  highestRatio: 'has the highest proportion',
  hour: 'Hour',
  hourhour: 'Answer duration exceeds average time',
  houryici: 'Use the previous parameters directly in this case',
  howScoreCalculated: 'How is the score calculated?',
  iKnow: 'Got It',
  id: 'Referrer ID',
  imageFormatJpgPngOnly: 'Only JPG, JPEG, and PNG formats are supported',
  imagePositionRequired: 'Image position is required. Please upload an image or remove this component',
  imageSizeExceed5M: 'Files larger than 5MB are not allowed',
  improvedScoreNum: 'Number of Students with Score Improvement',
  info: 'Information Missing',
  infoMissing: 'Information Missing',
  initialPassword: 'Initial Password',
  initialPasswordLabel: 'Initial Password',
  instinctExplain: 'Instinct-Level Explanation',
  internalAccountTip1: 'Internal trial accounts must be linked to an employee Squirrel Ai account. Please select the correct employee account',
  internalAccountTip2: 'Only employees with an "Active" status can apply for internal trial accounts',
  introducerOrChannelAgentId: 'Referrer / Channel Master Franchisee ID',
  invalidMobileFormat: 'Invalid phone number format',
  investorRoleCannotModify: 'The primary investor role cannot be modified',
  isFirstReward: 'First-Time Reward',
  ji: 'Cumulative Channel Level',
  jidao: 'Upgrade To',
  jie: 'Frozen',
  jinzhanghu: 'Gold Account',
  knowledgeNote: 'Learning Notes',
  lastMonthHighActiveRate: 'Last Month High Activity Rate',
  leads: 'Leads',
  learnTimeLabel: 'Learning Duration',
  learningAccountStatus: 'Learning Account Status',
  learningAccountExpired: 'Expired',
  learningAccountViolationDisabled: 'Disabled for Violation',
  leaveDateLabel: 'Termination Date',
  leaveMidway: 'Left Midway',
  leaveTimeLabel: 'Termination Time',
  level: 'Level',
  levelOne: 'Level 1',
  levelTwo: 'Level 2',
  levelThree: 'Level 3',
  levelFour: 'Level 4',
  levelFive: 'Level 5',
  levelSix: 'Level 6',
  levelSeven: 'Level 7',
  levelEight: 'Level 8',
  levelNine: 'Level 9',
  levelTen: 'Level 10',
  listenRecording: 'Listen to Recording',
  loginPassword: 'Login Password:',
  mainSystem: 'Main System:',
  male: 'Male',
  markSupervisorInfo: 'Mark Instructor Info',
  mathBaseDuration: 'Math Foundation Total Duration',
  mathBaseProgress: 'Math Foundation Max Progress',
  messageExport: 'Export Messages',
  messageReadUserCount: 'Number of Readers',
  messageSendDate: 'Send Date',
  messageSendUserCount: 'Number of Recipients',
  midtermExam: 'Midterm Exam',
  min: 'Error Analysis',
  minhour: 'During pagination',
  mobile: 'Phone Number',
  mobileModifyTip: 'Note: To change an employee’s login phone number, the employee must log in and update it in the Account Security Center',
  mobileModifyTip2: 'Note: To change an employee’s phone number, the employee must log in and update it in the Account Security Center after account activation',
  modifyAnalyst: 'Modify Analyst',
  modifyInfoSuccess: 'Information updated successfully',
  modifyRecord: 'Modification Record',
  modifySuccess: 'Updated successfully',
  month: 'Month',
  monthDataLabel: 'Monthly Data',
  monthActive: 'Monthly Active',
  more: 'More',
  msgDesc: 'Description',
  msgTitle: 'Title',
  name: 'Name',
  nameLabel: 'Name:',
  namePlaceholder: 'Name',
  nameRequired: 'Name is required',
  newOrderNo: 'Latest Purchase Order Number',
  newStudentName: 'New Student Name',
  newStudentNameOrPhone: 'New Student Name or Phone Number',
  newStudentPeriod: 'New Student Period',
  newSupervisorNum: 'Newly Assigned Instructor Students',
  newSupervisorNumTip: 'Number of students newly marked as self-study or online-only this month',
  nineMonthRetentionRate: '9-Month Retention Rate',
  nineMonths: '9 Months',
  noCollectNum: 'Number of Students Without Collected Scores',
  noDraftCorrectRate: 'Accuracy Rate Without Draft Work',
  noExceptionThisWeek: 'No exceptions this week!',
  noQualifiedStudents: 'No students meet the criteria',
  noRecording: 'No Recording Uploaded',
  noSupervisorActiveNum: 'Active Students Without Instructor',
  noSupervisorNum: 'Students Without Instructor',
  noSupervisorNumTip: 'Without instructor: students not marked with instructor status, or instructor status expired / not assigned',
  normal: 'Normal',
  notApplied: 'Not Applied',
  notCompleted: 'Not Completed',
  num: 'Shipment Quantity',
  onlineOnlyNum: 'Online-Only Students',
  onlyOneComponentTip: 'Only one component can be added here',
  opDesc: 'Operation Description',
  opTime: 'Operation Time',
  opType: 'Operation Type',
  opUser: 'Operator',
  opUserLabel: 'Operator',
  operation: 'Operation',
  optional: 'Optional',
  order: 'Fission Amount for Shipped but Unpaid Credit Orders',
  orderAmount: 'Order Amount',
  orderCreateTime: 'Order Creation Time',
  orderNo: 'Order Number',
  orderQuantity: 'Order Quantity',
  orderStatus: 'Order Status',
  orderStatusLabel: 'Order Status',
  orderTime: 'Order Time',
  orderType: 'Order Type',
  outerDisplayMobile: 'Displayed Phone Number:',
  pagePermissionConfig: 'Page Permission Configuration',
  pagePermissionDesc: 'Defines which pages employees can access',
  paidAmount: 'Amount Received',
  password: 'Password',
  passwordResetSuccess: 'Password has been reset to songguo123',
  passwordResetSuccessMsg: 'Password for account {name} has been reset to songguo123',
  passwordResetTo: 'Password for account {name} has been reset to songguo123',
  payStatus: 'Payment Status',
  payStatusLabel: 'Payment Status',
  payStatusNotPaidInFull: 'Partially Paid',
  payStatusReceived: 'Received',
  payStatusUnpaid: 'Unpaid',
  accountDraft: 'Draft',
  payedTotalAccountAmount: 'Total Cash Paid',
  payedTotalVoucherAmount: 'Total Voucher Deduction Paid',
  paymentTime: 'Payment Time',
  pending: 'Pending Confirmation',
  pendingConfirm: 'Pending Confirmation',
  permissionCheckTip: '*Please select the permissions for this role below',
  person: 'People',
  pineconeOrder: 'Pinecone Order',
  playRecording: 'Play Recording',
  pleaseEnter: 'Please enter the purchase order number',
  pleaseEnterPlain: 'Please enter',
  pleaseEnterAdName: 'Please enter the ad name',
  pleaseEnterBindMobile: 'Please enter the bound phone number',
  pleaseEnterCorrectMobile: 'Please enter a valid phone number',
  pleaseEnterEmail: 'Please enter an email address',
  pleaseEnterLoginPassword: 'Please enter the login password',
  pleaseEnterMobile: 'Please enter a phone number (used for password recovery)',
  pleaseEnterMsgTitle: 'Please enter the message title',
  pleaseEnterName: 'Please enter the name',
  pleaseEnterOrderNo: 'Please enter the order number',
  pleaseEnterProductName: 'Please enter the product name',
  pleaseEnterPurchaseOrderNo: 'Please enter the purchase order number',
  pleaseEnterRemark: 'Please enter remarks',
  pleaseEnterSchoolName: 'Please enter the school name',
  pleaseEnterStudentName: 'Please enter the student name',
  pleaseEnterStudentPhone: 'Please enter the student’s phone number',
  pleaseEnterTrueName: 'Please enter your full name',
  pleaseEnterVerifyCode: 'Please enter the verification code',
  pleaseFillExpressNo: 'Please enter the tracking number!',
  pleaseFillMsgDesc: 'Please enter the message description',
  pleaseFillOrderTimeOrDispatchTime: 'Please enter the order time or shipping time first',
  pleaseFillPageName: 'Please enter the page name in page settings',
  pleaseFillRoleName: 'Please enter the custom role name',
  pleaseSelect: 'Please select',
  pleaseSelectAccountStatus: 'Please select the account status',
  pleaseSelectAccountType: 'Please select the account type',
  pleaseSelectActivityTimeRange: 'Please select the activity start and end time',
  pleaseSelectAdPosition: 'Please select the ad placement',
  pleaseSelectAddStudents: 'Please select students to add',
  pleaseSelectAgent: 'Please select a Master Franchisee',
  pleaseSelectAgentNo: 'Please select the agent number',
  pleaseSelectAgentType: 'Please select the Master Franchisee type',
  pleaseSelectAnalyst: 'Please select an analyst',
  pleaseSelectAnalystAccountStatus: 'Please select the analyst account status',
  pleaseSelectCallSystem: 'Please select the call system',
  pleaseSelectDisNo: 'Please select the outbound caller ID',
  pleaseSelectEmployee: 'Please select an employee',
  pleaseSelectExpressCompany: 'Please select the logistics company',
  pleaseSelectExtNo: 'Please select the extension number',
  pleaseSelectGender: 'Please select gender',
  pleaseSelectHandover: 'Please select a handover person first!',
  pleaseSelectLinkData: 'Please select data to link',
  pleaseSelectMainSystem: 'Please select the main system first',
  pleaseSelectMonth: 'Please select a month',
  pleaseSelectOrderStatus: 'Please select the order status',
  pleaseSelectOrderType: 'Please select the order type',
  pleaseSelectOuterDisplayMobile: 'Please select the displayed phone number',
  pleaseSelectPayStatus: 'Please select the payment status',
  pleaseSelectPerson: 'Please select a person',
  pleaseSelectProductType: 'Please select the product type',
  pleaseSelectRemoveStudents: 'Please select students to remove',
  pleaseSelectSchoolRegion: 'Please select the school province/city/district',
  pleaseSelectStatus: 'Please select status',
  pleaseSelectSubject: 'Please select the subject',
  pleaseSelectSupervisor: 'Please select an Instructor',
  pleaseSelectSupervisorStatus: 'Please select the Instructor status',
  pleaseSelectTeachingStage: 'Please select the teaching stage(s)',
  pleaseSelectTeachingSubject: 'Please select the teaching subject',
  pleaseSelectUpgradeLevel: 'Please select the upgrade level first',
  pleaseSelectWarehouse: 'Please select a warehouse',
  pleaseSelectYear: 'Please select a year',
  placeholderSelectMonth: 'Please select a month',
  monthLabel: 'Month',
  monthNumberLabel: '{n} Month',
  allOption: 'All',
  pleaseUploadFacePhoto: 'Please upload a front-facing photo that meets the requirements',
  pleaseUploadImage: 'Please upload an image',
  pointsSuffix: 'points',
  potentialCustomer: 'Potential Customer',
  previewPermission: 'Preview Permissions',
  price: 'Cash Unit Price',
  priceIncreaseAmount: 'Price Increase Amount',
  productModel: 'Product Model',
  productName: 'Purchased Product Name',
  productPrice: 'Purchase Unit Price',
  productType: 'Product Type',
  province: 'Province',
  provinceActivateExport: 'Province Activation Report Export',
  provinceAverage: 'Province Average',
  provinceCityDistrict: 'Province / City / District',
  provincialPending: 'Pending Provincial Review',
  purchase: 'Purchase Unit Price',
  purchaseAmount: 'Purchase Amount',
  purchaseNum: 'Purchase Quantity',
  purchaseOrderNo: 'Purchase Order Number',
  purchaseOrderValueExport: 'Purchase Order Value Report Export',
  purchaseQuantity: 'Purchase Quantity',
  purchaseTotalAmount: 'Total Purchase Amount',
  purchaseUnitPrice: 'Purchase Unit Price',
  qing: 'Applicant',
  quantity: 'Quantity',
  qudai: 'Regional Master Franchisee ID',
  qudaifen: 'Regional Master Franchisee Shared Value-Added Service Fee',
  qudaifending: 'Regional Master Franchisee Shared Subscription Rebate',
  queryDate: 'Query Date',
  questionCount: 'Number of Problems',
  questionMarkRateLabel: 'Problem Annotation Rate',
  quickConfigTip: 'Please select a sub-account role. The system will automatically configure the required permissions',
  quickConfigTip2: '(You can adjust the configuration manually afterward)',
  quickIdentity: 'Quick Custom Role',
  quickSearchAddPermission: 'Quick Search to Add Permissions',
  reInvite: 'Reinvite',
  reInviteSuccess: 'Invitation resent. Please ask the employee to check DingTalk',
  reactivate: 'Reactivate',
  readCircle: 'Reading Annotation',
  readCircleCoverageRate: 'Reading Annotation Coverage Rate',
  readCircleEffectiveRate: 'Reading Annotation Effectiveness Rate',
  readCircleHelp: 'How to annotate while reading effectively?',
  reapply: 'Reapply',
  receiveAddress: 'Shipping Address',
  receiveByName: 'Recipient Name',
  recentThreeScores: 'Last Three Scores',
  rechargeTime: 'Recharge Time',
  referralContractAmount: 'Referral Contract Amount',
  referralCustomerId: 'Referral Customer ID',
  referralCustomerName: 'Referral Customer Name',
  regionAgentId: 'Regional Master Franchisee ID',
  regionShareSubscriptionRebate: 'Regional Master Franchisee Subscription Rebate Share',
  regionShareValueAddedFee: 'Regional Master Franchisee Value-Added Service Fee Share',
  rejected: 'Rejected',
  release: 'Release',
  remark: 'Remark',
  remove: 'Remove',
  removeFail: 'Remove failed',
  removeFailed: 'Remove failed',
  removeSuccess: 'Removed successfully',
  renew: 'Renew',
  renewSuccess: 'Renewed successfully',
  experienceRenewConfirmTip: 'Each renewal extends the subscription by one year. After submission, the employee learning account for {name} will be renewed. Please ensure proper usage. Do you want to continue?',
  replenishmentTime: 'Restock Time',
  requestFailRetry: 'Request failed. Please try again later',
  resendAfter: 'Resend after {count}s',
  resetFailed: 'Reset failed',
  resetPassword: 'Reset Password',
  resetPasswordAfterTip: 'After reset, the password will be the default password [songguo123]',
  resetPasswordConfirm: 'Are you sure you want to reset this account?',
  resetPasswordTip: ' login password',
  resetPasswordTitle: 'Reset Password',
  resetSuccess: 'Reset successful',
  resign: 'Terminate Employment',
  resignAssetTip: 'This account has the following assets. Please choose to release or transfer them',
  resignConfirmTip: 'After submission, all data associated with {name} ({mobile}) will be cleared, and the DingTalk account will be removed. This action cannot be undone. Do you want to continue?',
  resignFailed: 'Termination failed',
  resignOperation: 'Termination Operation:',
  resignRecord: 'Termination Record',
  resignSuccess: 'Termination successful',
  resignSuccessTip: 'After termination, this account will be removed from ID {campusId} and cannot be restored',
  resigned: 'Terminated',
  responsibleSupervisor: 'Responsible Instructor',
  restart: 'Restart',
  returnBackPayValue: 'Payment Returned',
  rewardAmount: 'Reward Amount',
  rewardRate: 'Reward Rate',
  sampleAccount: 'Demo Device Account',
  san: 'Level 3',
  save: 'Save',
  saveFailed: 'Save failed',
  saveSuccess: 'Saved successfully',
  schoolDataBase: 'Resource Library',
  schoolYear: 'School Year',
  score: 'Score',
  scoreCollectRate: 'Score Collection Rate',
  scoreCollected: 'Total Scores Collected',
  scoreImprovementRate: 'Score Improvement Rate',
  scoreLabel: 'Score',
  scoreManage: 'Score Management',
  scoreRule1Basis: 'Scoring is based on the average weekly learning duration of students managed by the Instructor',
  scoreRule1Text1: 'Spring & Fall: 10 points for an average of 6 hours per week',
  scoreRule1Text2: 'Winter & Summer: 10 points for an average of 20 hours per week',
  scoreRule1Text3: 'Monthly score = average of all weekly scores in the month',
  scoreRule1Title: '1. Learning Duration',
  scoreRule2Basis: 'Scoring is based on the proportion of highly active students managed by the Instructor',
  scoreRule2Text1: 'Using the national average as a baseline, every 10% above adds 1 point, every 10% below subtracts 1 point',
  scoreRule2Text2: 'Monthly score = average of all weekly scores in the month',
  scoreRule2Title: '2. High Activity',
  scoreRule3Basis: 'Scoring is based on abnormal learning behavior of students managed by the Instructor',
  scoreRule3Text1: 'Each student starts with 10 points per week; points are deducted for abnormal behavior',
  scoreRule3Text2: 'Different levels of abnormal behavior result in different deductions; standards vary by season',
  scoreRule3Text3: 'Weekly score is the average score of students managed by the Instructor',
  scoreRule3Text4: 'Monthly score = average of all weekly scores in the month',
  scoreRule3Title: '3. Abnormal Learning Behavior',
  scoreRule4Basis: 'Scoring is based on the learning trace rate during the Instructor process',
  scoreRule4Text: 'Score = average learning trace rate × 10',
  scoreRule4Title: '4. Learning Trace',
  scoreRule5Basis: 'Scoring is based on the 3-month service retention rate of Instructor outcomes',
  scoreRule5Text1: 'Score = 3-month service retention rate × 10',
  scoreRule5Text2: 'Note: This metric does not apply to new Instructors (within 3 months)',
  scoreRule5Title: '5. 3-Month Service Retention Rate',
  scoreRuleTotalDesc: 'The total score (out of 10) is determined by performance across the five dimensions above.',
  search: 'Search Analyst:',
  searchAnalyst: 'Search Analyst:',
  secmin: 'Convert Seconds to Minutes',
  securityVerification: 'Security Verification',
  selectEmployee: 'Select Employee:',
  selectMainSystem: 'Select System',
  selectRolePermission: 'Select Role Permissions',
  selfProcessExplain: 'Self-Process Explanation',
  selfScoreLabel: 'Self-Evaluation',
  selfStudyNum: 'Number of Self-Study Students',
  send: 'Send',
  sendFail: 'Send failed',
  sendSuccess: 'Sent successfully',
  serviceCenterAllStudents: 'All Students in the Learning Center',
  serviceRetentionRate: 'Service Retention Rate',
  serviceRetentionRateTip: '3-month service retention rate: Of the students transferred to the Learning Center 3 months ago, the percentage who are still in the center this month with ≥4 hours of study time.\nThe 6-, 9-, and 12-month retention rates follow the same logic, with extended timeframes.',
  serviceTeacher: 'Instructor',
  settlementMonth: 'Settlement Month',
  shi: 'Tens Place',
  shu: 'Reward Coefficient',
  sixMonthRetentionRate: '6-Month Service Retention Rate',
  sixMonths: '6 Months',
  skipVideo: 'Skip Video',
  snCode: 'Device SN Code',
  softwareActivateTime: 'Software Activation Time',
  softwareActiveMonth: 'Software Activation Month',
  softwareActiveStatus: 'Software Activation Status',
  splitUser: 'Order Split Assignee',
  splittingTime: 'Order Split Time',
  springTerm: 'Spring Term',
  squirrelOrder: 'Squirrel Order',
  stageGrade: 'Grade Level',
  statsPeriodLabel: 'Reporting Period',
  status: 'Analytics Account Status',
  student: 'Student',
  studentAccount: 'Student Account',
  studentData: 'Student Data',
  studentInfoIncomplete: 'Student information is incomplete and cannot be removed',
  studentManage: 'Student Management',
  studentNameLabel: 'Student Name',
  studentPhoneLabel: 'Student Phone Number',
  studentsCount: 'students',
  studentsOfTeacher: 'Students managed by {name}',
  studyAbnormal: 'Abnormal Learning Behavior',
  studyAbnormalHelp: 'What should be done when abnormal learning behavior occurs?',
  studyAbnormalOverview: 'Abnormal Learning Overview',
  studyAbnormalScene: 'Abnormal Learning Scenarios',
  studyAccuracy: 'Learning Accuracy',
  studyDuration: 'Learning Duration',
  studyMonitorAlert: 'Learning Monitoring Alert Description',
  studyTrace: 'Learning Trace',
  subject: 'Subject',
  subjectLabel: 'Subject',
  submit: 'Submit',
  submitFailed: 'Submit failed',
  submitScoreNum: 'Number of Students with Submitted Scores',
  submitSuccess: 'Submitted successfully',
  submitTwiceNum: 'Number of Students Submitting Scores Twice',
  subscribeSubject: 'Subscribed Subject',
  subscriptionFeeAmount: 'Subscription Fee Amount',
  subscriptionFeeRebate: 'Subscription Fee Rebate',
  subsequentError: 'Subsequent Errors',
  summaryFillCount: 'Number of Summary Entries',
  superviseStudent: 'Students Managed by Instructor',
  supervising: 'In Progress',
  supervisor: 'Instructor:',
  supervisorColon: 'Instructor:',
  supervisorData: 'Instructor Data',
  supervisorLabel: 'Instructor:',
  supervisorManage: 'Instructor Management',
  supervisorName: 'Instructor Name',
  supervisorNoData: 'No data available for {names} and {count} other Instructors',
  supervisorStatus: 'Instructor Status',
  supervisorStudents: 'Students Managed by Instructor',
  supervisorSummaryCoverageTip: 'Instructor summary coverage rate: the proportion of subject-student combinations with ≥50 minutes of weekly study time where a summary was completed',
  supervisorSummaryFillRate: 'Summary Completion Rate',
  supervisorSummaryLabel: 'Instructor Summary',
  supervisorSummaryWeek1: 'Instructor summary coverage rate, Week 1',
  supervisorSummaryWeek2: 'Instructor summary coverage rate, Week 2',
  supervisorSummaryWeek3: 'Instructor summary coverage rate, Week 3',
  supervisorSummaryWeek4: 'Instructor summary coverage rate, Week 4',
  supervisorSummaryWeek5: 'Instructor summary coverage rate, Week 5',
  studentSummaryFillRate: 'Instructor summary completion rate',
  supervisorValidUntil: 'Instructor Valid Until',
  supplementReward: 'Supplemental Rebate',
  teacher: 'Analyst',
  teacherManage: 'Analyst Management',
  teacherManagement: 'Analyst Management',
  teacherNameLabel: 'Instructor Name',
  teacherScoreManage: 'Instructor Score Management',
  teachingStage: 'Teaching Stage',
  teachingSubject: 'Teaching Subject',
  tenPoints: '10 Points',
  term: 'Term',
  text0gz9: 'Extract different items',
  text0mll: 'If the current digit is',
  text0tr2: 'Or the search criteria have changed',
  text0w3u: 'Accuracy of draft-based problems',
  text0w9z: 'Instructor process',
  text0x15: 'Set all to default',
  text17ch: 'Instructor data',
  text1926: 'Check whether it is a valid number',
  text2vs2: 'And the answer is incorrect',
  text39f7: 'Use slots for custom display',
  text3mvs: 'Retrieve all Instructors',
  text3pv9: 'Convert to numeric type',
  text3u4k: 'Service retention rate',
  text3xl2: 'Process',
  text40ep: 'Structure',
  text489f: 'Answered too slowly',
  text48yo: 'Answered too slowly and incorrectly',
  text49aa: 'Draft step completion rate',
  text4h9c: 'Answered incorrectly',
  text4t75: 'Problem marking behavior',
  text627i: 'Single week',
  text6g6k: 'Sample Problem attempt accuracy',
  text6ntj: 'Then',
  text7141: 'Completed',
  text76xd: 'Use',
  text78b4: 'Incorrect Sample Problem attempt and unable to solve after watching the video',
  text7hj4: 'Instead of',
  text82nx: 'Severity Level',
  text8f95: 'Play Music',
  text8mo7: 'Task Card',
  text8ocs: 'Display as',
  text9437: 'Please select an Instructor',
  text99pk: 'Tag stop playback event',
  text9fgp: 'Customize display via named slots',
  text9g2t: 'Number of Sample Problem attempts',
  text9rrm: 'Register global event listener',
  text9vdz: 'Provide Instructor data to child components',
  text9ymf: 'Weekly Data',
  texta01x: 'Of total Problems',
  texta4yg: 'Or not played',
  texta9jk: 'Learning Objective',
  textafry: 'Directly import for use in other modules',
  textah6t: 'For comparison',
  textaj3b: 'Need to add',
  textas1f: 'Not focused',
  textatdj: 'Compare two arrays',
  textb13r: 'Custom event name',
  textb1td: 'Unsubscribe',
  textb3iv: 'Transform data format',
  textb42m: 'Configuration table for abnormal levels and severity',
  textb57b: 'Exceeds per week',
  textb9f4: 'Instructor',
  textbnko: 'Instructor outcomes',
  textbw1c: 'Use slot type',
  textc6ge: 'Instructor development',
  textcbtu: 'Trial-and-error results',
  textclml: 'Or manually cleared before clicking search',
  textd04f: 'Learning Accuracy',
  textdbku: 'Number of Problems answered too slowly or too quickly and incorrectly',
  texte5xq: 'Requires special handling',
  texte71e: 'Abnormal Level',
  textehfn: 'Accuracy of Problems without draft work',
  texteoqz: 'Playback ended',
  textfri7: 'Left the learning interface',
  textg9jw: 'Not qualified',
  textg9lu: 'Overall accuracy',
  textg9q3: 'Sample Problem attempt trace rate',
  textgq8m: 'Draft qualification rate',
  texthcky: 'Remove event listener',
  texthhgq: 'Student data',
  texthmgc: 'Consecutive errors',
  texthvgt: 'High activity rate',
  texthyxj: 'Skipped video and answered incorrectly',
  texti83z: 'Exceeds',
  texticoe: 'Listen',
  textif5e: 'Playback progress',
  textiixp: 'For digit-by-digit processing',
  textio06: 'Process data',
  textiqb0: 'Incorrect answer',
  textj0nj: 'Spot-check evaluation of Sample Problem attempts',
  textj25c: 'Instructor data table title',
  textj3ol: 'Not attempted',
  textj5rx: 'Click',
  textj9q6: 'Instructor Name',
  textjml8: 'Total number of Problems',
  textjo43: 'Subsequent Problems answered incorrectly',
  textkm2l: 'Playback can start event',
  textkoo8: 'Ones place',
  textl7dp: 'And accuracy',
  textlmp2: 'Low Sample Problem attempt rate',
  textlysd: 'Alert status',
  textmgeu: 'Instructor data table data',
  textmj7g: 'Draft step writing performance',
  textml6j: 'Position from right to left',
  textmvg4: 'Add numbers and units',
  textmxwo: 'Tag pause event',
  textn2me: '{count} Instructors have no data',
  textn6iq: 'Get playback position',
  textn73g: 'Course level',
  textnbar: 'Cached data',
  textneeb: 'Qualified',
  textnz99: 'Convert array structure to',
  textoida: 'Video-based Sample Problem attempt performance',
  textoros: 'Update current component',
  textot2j: 'Tag audio loaded event',
  textowbi: 'Low draft writing rate',
  textp2cw: 'Convert number to string',
  textp3v5: 'So this must be set to',
  textpi0u: 'Problem marking trace rate',
  textpq4z: 'Correct attempt',
  textpr2f: 'Number of draft steps written',
  textpruy: 'Idle',
  textq0ee: 'Compare with all Instructor list',
  textqp4o: 'Video',
  textr44b: 'Original panel',
  textrcak: 'Spring & Fall',
  textrfhl: 'Learning Objective notes',
  textri2f: 'Answered too quickly',
  textrqvd: 'Learning status offline',
  textsp46: 'Skip video',
  textt2sn: 'High activity rate',
  textt9gm: 'Consecutive occurrences',
  texttcnp: 'Service retention rate',
  textte0m: 'Basic number mapping',
  texttsu0: 'Trigger condition',
  textu6da: 'Total number of Instructor data records',
  textujf7: 'Playback status',
  textuom8: 'Incorrect Sample Problem attempt but able to solve after watching the video',
  textup01: 'Draft trace rate',
  textv7bp: 'Configuration table for learning monitoring alerts',
  textv7f9: 'Wait for audio to finish loading',
  textvbft: 'Winter & Summer',
  textw0yx: 'Skipped video and answered incorrectly',
  textw70q: 'Sample Problem attempt rate',
  textw887: 'Problem attempted',
  textwfar: 'Total number of videos',
  textwnem: 'Click clear button',
  textwnfr: 'Abnormal scenarios triggered in a single week',
  textxq0a: 'Incorrect answers in Problems',
  textxus0: 'Left midway',
  textxw4v: 'Otherwise all should be default',
  texty2le: 'Accuracy of Problems without draft work',
  texty46b: 'Audio playback',
  texty6ox: 'New student management',
  textyiin: 'Instructor data',
  textyk6y: 'Drag the panel progress bar',
  textylh1: 'Handle playback start event',
  textynd0: 'Draft qualification rate',
  textypuv: 'All Problems attempted',
  textys7i: 'Random answering',
  textz0mj: 'Handle special cases',
  textzgl8: 'Answered too quickly and incorrectly',
  textzmi8: 'Format',
  textznuz: 'Learning Objective note trace rate',
  textzpjo: 'Only query active teachers',
  textzrhn: 'Mapping',
  textzt6o: 'Summary completion rate',
  textzun2: 'Unable to continue learning',
  thisMonthHighActiveRate: 'High activity rate this month',
  threeMonthRetention: '3-month service retention',
  threeMonthRetentionRate: '3-Month Service Retention Rate',
  threeMonths: '3 Months',
  time: 'Time',
  times: 'Count',
  timesDesc: 'Count description',
  tizhanghu: 'Delivery Voucher Account',
  totalAccountAmount: 'Total cash amount (including vouchers)',
  totalCorrectRate: 'Overall accuracy',
  totalErrorCount: 'Total number of incorrect Problems',
  totalLearnTime: 'Total learning time',
  totalPrice: 'Total unit price',
  totalReturnedAmount: 'Total returned amount',
  totalScore: 'Total score',
  totalScoreLabel: 'Total Score',
  totalStudyDuration: 'Total study duration',
  totalVoucherAmount: 'Fission bonus amount',
  transferCampusId: 'Shipping Region Agent ID',
  transferCampusName: 'Shipping Region Agent Name',
  trialAccount: 'Trial Account',
  trialDate: 'Trial date',
  trialErrorKnowledge: 'Learning Objectives with incorrect attempts',
  trialErrorResult: 'Trial-and-error result',
  trialErrorWatchVideoNotOk: 'Incorrect Sample Problem attempt and still unable after watching the video',
  trialErrorWatchVideoOk: 'Incorrect Sample Problem attempt but able after watching the video',
  trialStillNotOkSuffix: 'Sample Problem attempts remain incorrect after watching the videos. Please follow up',
  trialStillNotOkTip: ', there are ',
  twelveMonthRetentionRate: '12-Month Service Retention Rate',
  twelveMonths: '12 Months',
  type: 'Account Type',
  unit: 'Count',
  updateFaceInfo: 'Update Face Information',
  updateTime: 'Update Time',
  uploadFail: 'Upload failed',
  uploadSizeExceed1MB: 'File size cannot exceed 1MB',
  uploadSuccess: 'Upload successful',
  uploadedImages: 'Uploaded Images',
  userName: 'Username',
  valueAddedServiceFee: 'Value-Added Service Fee',
  verifyCode: 'Verification Code:',
  verifyFailed: 'Verification failed!',
  verifySuccess: 'Verification successful!',
  view: 'View',
  viewAccountPassword: 'View Account Password',
  viewAll: 'View All >',
  viewDetail: 'View Details',
  viewFail: 'View failed',
  viewImage: 'View Image',
  viewStudent: 'View Student',
  viewStudentLabel: 'View Student',
  viewSummary: 'View Summary',
  viewTrialErrorKnowledge: 'View Learning Objectives with incorrect attempts',
  voucherPrice: 'Fission Unit Price',
  vsLastMonth: 'vs last month',
  wake: 'Activate',
  wakeConfirmTip: 'After activation is submitted, the account associated with {username} ({phone}) will regain access to {systemName} and be added to the {campusId} DingTalk organization. Please confirm whether to proceed.',
  wakeFailed: 'Activation failed',
  wakeSuccess: 'Activation successful',
  warehouse: 'Warehouse',
  week: 'Reporting Period',
  weekAlarmCount: 'Total alerts this week',
  weekEndDate: 'Week (end date)',
  weekErrorAnalysisRate: 'Weekly error analysis completion rate (Levels 1–6)',
  weekTrialRatio: 'Weekly Sample Problem attempt rate',
  weight: 'Weight',
  weight25: '25%',
  weightNewOld: '25% (new) / 25% (existing)',
  weightRetention: '0% (new) / 10% (existing)',
  withdraw: 'Withdrawal Account',
  within10Chars: 'Within 10 characters',
  within30Chars: 'Within 30 characters',
  wrongAndNotOk: 'Incorrect and still not understood',
  wrongAndOk: 'Incorrect but now understood',
  wu: 'Invalid',
  year: 'Year',
  yearSuffix: 'Year',
  yes: 'Reward issued',
  yi: 'Level 1',
  yihour: 'Time per Problem',
  yishi: 'Ten',
  yixunCallSystem: 'Yixun Call System',
  yong: 'Disabled',
  yonge: 'Available Balance',
  you: 'Valid',
  youqi: 'Validity Period',
  zhanghu: 'Fission Account',
  actualAmount: 'Actual Payment Amount',
  export: 'Export',
  hao: 'Purchase Order No.',
  text0o0d: 'Purchase Quantity',
  text23z5: 'Manufacturer Shipment Management',
  text2b7i: 'Cash Account',
  text3m5o: 'Import Details',
  text8kdk: 'Fission Bonus Account',
  text8ojn: 'Import Details List',
  textb2w1: 'Or manually cleared before clicking search',
  textbsxw: 'Click clear button',
  textc66c: 'Download import results',
  textffcb: 'Delivery Voucher Account',
  textfkn9: 'Then',
  texthgq2: 'Account Balance',
  texti0u5: 'Imported',
  textj87y: 'Purchase Amount',
  textke1h: 'Unsubscribe',
  textkf9v: 'Import Type',
  textkh28: 'Gold Account',
  textm22h: 'Otherwise all should be default',
  textn0ux: 'Maximum deductible amount',
  textose4: 'Set all to default',
  textspvo: 'Available Amount',
  textuuw6: 'Total data volume',
  textvla9: 'Table data query',
  textym5z: 'Or the search criteria have changed',
  textzx8x: 'Not imported',
  auto_114_bf5738cf: 'Not required at this time',
  auto_115_54bf2acb: 'Not attempted',
  auto_116_6ce2c91b: 'Problem attempted',
  auto_117_5a0eda5e: 'Problem attempted',
  auto_118_c996d044: 'Problem attempted',
  auto_119_47f91cb3: 'All Problems attempted',
  auto_120_87db356c: 'Completed',
  auto_121_dac8b361: 'Not attempted',
  auto_122_6d225d37: 'Not required at this time',
  auto_123_b8340646: 'Qualified',
  auto_124_13c6e860: 'Not qualified',
  auto_125_b455aa66: 'Level 1',
  auto_126_52e5e119: 'Level 2',
  auto_127_601a8062: 'Exceeded threshold in a single week or across consecutive weeks',
  auto_128_9f36d418: 'Level 3',
  auto_129_5823f537: 'Exceeded threshold in a single week or across consecutive weeks',
  auto_130_82661969: 'Learning status offline',
  auto_131_c2c2e569: 'Idle or left midway during the day',
  auto_132_ab17e28a: 'Unable to continue learning',
  auto_133_435003ac: 'Number of consecutive errors per day',
  auto_134_39dc31a3: 'Random answering',
  auto_135_c36ab2f9: 'Number of Problems answered too quickly per day',
  auto_136_9b4acfbb: 'Not focused',
  auto_137_e0addb98: 'Number of Problems answered too slowly per day',
  auto_138_44b28708: 'Repeatedly skipped videos and answered incorrectly',
  auto_139_6ca2cf8a: 'Skipped videos and subsequent Problems answered incorrectly',
  auto_140_05a4538b: 'Low draft writing rate',
  auto_141_19e584cd: 'Daily draft writing rate below threshold',
  auto_142_599c751f: 'Low Sample Problem attempt rate',
  auto_143_f7e255db: 'Daily Sample Problem attempt rate',
  auto_144_6ce6fdb2: 'Low error analysis completion rate',
  auto_145_82ea5516: 'Weekly error analysis completion rate (by level)',
  auto_146_34ea6de7: 'Insufficient learning duration',
  auto_147_0ddc1e9b: 'Weekly learning duration below threshold (Spring & Fall)',
  auto_148_8be52cf5: 'Idle',
  auto_149_e1cbdb93: 'Stayed on the same page without activity beyond threshold duration',
  auto_150_3a20f613: 'Left midway',
  auto_151_5adffc36: 'Left the learning interface',
  auto_152_19f7a463: 'Consecutive errors',
  auto_153_3771d346: 'Consecutive incorrect answers',
  auto_154_86a7f26f: 'Answered too slowly and incorrectly',
  auto_155_5c563bec: 'Answer time exceeded average duration',
  auto_156_4a5bd9d8: 'Answered too quickly and incorrectly',
  auto_157_4fa255ac: 'Skipped video and answered incorrectly',
  auto_158_b950ac31: 'Number of idle or leave-midway occurrences',
  auto_159_19fcd54d: 'Learning status offline',
  auto_160_11540b79: 'Unable to continue learning',
  auto_161_cdda286b: 'Random answering',
  auto_162_73c63a4c: 'Not focused',
  auto_163_4706dfb4: 'Skipped video and answered incorrectly',
  auto_164_5eb2cb24: 'Low draft writing rate',
  auto_165_32b092a6: 'Low Sample Problem attempt rate',
  auto_166_bb0dec1c: 'Low error analysis completion rate',
  auto_167_7c265b59: 'Insufficient learning duration',
  auto_168_d53fd8ce: 'Idle',
  auto_169_dfaf2fe9: 'Left midway',
  auto_170_694677ae: 'Consecutive errors',
  auto_171_197284ff: 'Answered too quickly',
  auto_172_9ce33983: 'Answered too slowly',
  auto_173_2a8aa150: 'Skipped video',
  auto_9_7702c220: 'Sample Problem attempts remain incorrect after watching the videos. Please follow up',
  auto_10_94d8dc85: 'Action',
  auto_72_200c7f02: 'Weekly total',
  auto_73_1aa0cbc1: 'Number of Problems',
  auto_74_f371ad39: 'Ratio',
  auto_75_f461c84a: 'Error category',
  auto_76_32e0744f: 'Problem comprehension issue',
  auto_77_ca6e3a94: 'Calculation error',
  auto_78_17d9fd5b: 'Unable to solve this Problem',
  auto_79_fec0a1ff: 'System identification error',
  auto_80_b56f5e7f: 'Other',
  auto_81_e848b086: 'Sunday',
  auto_82_50b93981: 'Monday',
  auto_83_57aa31d8: 'Tuesday',
  auto_84_a073d31c: 'Wednesday',
  auto_85_8e0080c1: 'Thursday',
  auto_86_0e2944a3: 'Friday',
  auto_87_d62a1027: 'Saturday',
  auto_88_d6d18239: 'Sunday',
  auto_89_91107ea9: 'Monday',
  auto_90_bfb825f6: 'Tuesday',
  auto_91_398b2be6: 'Wednesday',
  auto_92_923a6343: 'Thursday',
  auto_93_167b0d71: 'Friday',
  auto_94_85c18c37: 'Saturday',
  auto_95_1f14b816: 'Completed',
  auto_96_fd486a7b: 'Not attempted',
  auto_97_3ac813a4: 'Not required',
  auto_98_c51048bb: 'Not required',
  auto_99_68c14998: 'Idle',
  auto_100_f163cf3e: 'Left midway',
  auto_101_d583cfee: 'Consecutive errors',
  auto_102_c7481dd3: 'Answered too slowly',
  auto_103_ea985fd9: 'Answered too quickly',
  auto_104_4bfe4284: 'Skipped video',
  auto_105_57d57fcb: 'Weekly total',
  auto_106_2761a940: 'Weekly total',
  auto_107_f5812327: 'Weekly total',
  auto_108_59fb5aa1: 'Abnormal learning behavior',
  auto_109_cbfa7f73: 'Consecutive weeks',
  auto_110_a746491a: 'Exceeded count',
  auto_111_543c525a: 'Consecutive weeks',
  auto_112_8c6b4fd7: 'Exceeded count this week',
  auto_113_85b7ea72: 'Ongoing',
  auto_1_92ac947e: 'Face photo specification',
  auto_1_af831ca6: 'Internal account tip',
  auto_2_8680ff0e: 'Face Photo Specification',
  auto_2_cdaf92ef: 'Internal Account Tip',
  auto_3_492f529f: 'Face Photo Specification',
  auto_5_6926543b: 'Renewal',
  auto_6_dcb6f800: 'The employee Learning Tablet account has enabled intelligent risk control. Face information must be uploaded when applying for an account',
  auto_46_0269e1a7: 'Name',
  auto_47_2c563fe1: 'Phone Number',
  auto_48_25b1635b: 'Employee Account Status',
  auto_49_67388bbd: 'Learning Tablet Account Status',
  auto_50_8c579ca9: 'Face Information Status',
  auto_51_ecb0aad5: 'Account',
  auto_52_623e4ad2: 'Password',
  auto_53_865532f4: 'Application Time',
  auto_54_9872669f: 'Applicant',
  auto_55_a0aaef39: 'Total Learning Duration',
  auto_56_9da20d34: 'Effective Foundation Learning Duration',
  auto_57_4404a352: 'Apply for Employee Learning Tablet Account',
  auto_58_d137d18a: 'This employee Learning Tablet account has not been recorded',
  auto_59_57b30a83: 'Employee Name',
  auto_60_d8558a9f: 'Apply for Employee Learning Tablet Account',
  auto_61_bfa0d9bd: 'Select Employee',
  auto_62_acd6af11: 'Supplement Face Information',
  auto_63_45ee5864: 'This employee Learning Tablet account has not been recorded',
  auto_64_9b6a6432: 'Employee Name',
  auto_65_12e98425: 'Update Face Information',
  auto_66_e952fd8b: 'Employee Name',
  auto_67_cc2666cb: 'The photo does not appear to be of an adult. Do you want to proceed?',
  auto_68_1eda70cf: 'Notice',
  auto_69_e81d7d59: 'Confirm',
  auto_70_900ca9ea: 'Cancel',
  auto_71_f97bdd1c: 'Only specific image formats are supported',
  auto_2_8ca8fe3a: 'Note: To change the employee phone number, the employee must log in and update it in the Account Security Center after activation',
  auto_3_185fe505: 'Franchisee System',
  auto_4_5a97edcd: 'Analytics Support System',
  auto_17_bf9a90f1: 'Hantian Call System',
  auto_18_1ad7b8b4: 'Hantian Call System',
  auto_19_1d37d402: 'Yixun Call System',
  auto_20_26847597: 'Yixun Call System',
  auto_21_171a6e64: 'Hantian Call System',
  auto_22_25772312: 'Investor',
  auto_23_8a044272: 'Hantian Call System',
  auto_24_551e9c46: 'Yixun Call System',
  auto_25_a4b78e20: 'Hantian Call System',
  auto_26_83f5dffb: 'Yixun Call System',
  auto_27_89da19db: 'Hantian Call System',
  auto_28_1c224ce0: 'Yixun Call System',
  auto_29_6fed4f90: 'Hantian Call System',
  auto_30_0f3124fe: 'Yixun Call System',
  auto_31_767a0f0a: 'Hantian Call System',
  auto_32_712e9572: 'Hantian Call System',
  auto_33_6ba38b4a: 'Investor',
  auto_186_ec018485: 'All',
  auto_187_52b1e87b: 'New Student Name',
  auto_188_59607ccf: 'New Student Period',
  auto_189_317f9f06: 'Responsible Instructor',
  auto_190_c6404dc3: 'Total Learning Duration',
  auto_191_b98e5332: 'Problem Marking Behavior',
  auto_192_1f1d4f0a: 'Draft Writing Performance',
  auto_193_027dea62: 'Sample Problem Attempt Performance',
  auto_194_c09bf149: 'Error Analysis',
  auto_195_b76e8428: 'Self-Process Explanation',
  auto_196_17bc2fdf: 'First Week Feedback',
  auto_197_e981487a: 'Instinct-Level Explanation',
  auto_198_4803b6e8: 'Learning Health Level Adjustment Explanation',
  auto_199_ed031edd: 'Recent Three Scores',
  auto_208_03332d86: 'No data available',
  auto_209_c2ddbe66: 'Score Collection Rate',
  auto_210_0e770f18: 'Number of Scores Collected',
  auto_211_08833df5: 'Students managed by Instructor',
  auto_212_99ec8ae3: 'Valid Score Rate',
  auto_213_735a30c2: 'Number of Valid Scores',
  auto_214_ca729786: 'Students managed by Instructor',
  auto_215_6018038c: 'Exam Score Improvement Rate',
  auto_216_d5526d42: 'Number of Students with Score Improvement',
  auto_217_1af8b376: 'Students managed by Instructor submitting scores twice',
  auto_218_e74b5add: 'Fall Term',
  auto_219_331c0d4a: 'Spring Term',
  auto_220_58b31698: 'Midterm Exam',
  auto_221_100dfbd5: 'Final Exam',
  auto_230_6776c21f: 'No data available',
  auto_231_13483fef: 'Score Collection Rate',
  auto_232_50e70984: 'Number of Scores Collected',
  auto_233_3d44a397: 'Students managed by Instructor',
  auto_234_6b5abcc2: 'Valid Score Rate',
  auto_235_83f283e7: 'Number of Valid Scores',
  auto_236_0b37fa51: 'Students managed by Instructor',
  auto_237_63eee629: 'Exam Score Improvement Rate',
  auto_238_fc1aae13: 'Number of Students with Score Improvement',
  auto_239_55dd988b: 'Students managed by Instructor submitting scores twice',
  auto_240_9a60e0ea: 'Fall Term',
  auto_241_7bdfad88: 'Spring Term',
  auto_242_79576c05: 'Midterm Exam',
  auto_243_77e933f3: 'Final Exam',
  auto_12_0a666e12: 'Export',
  auto_34_4bac84df: 'Name',
  auto_35_b2bf97cf: 'Name',
  auto_36_b99b6c5e: 'Termination Date',
  auto_37_f5c5a2ff: 'Name',
  auto_38_6cdce436: 'Phone Number',
  auto_39_a4ff4163: 'Termination Time',
  auto_40_72825acf: 'Operator',
  auto_41_923e5f12: 'Created Time',
  auto_42_12e670c5: 'Potential Customer',
  auto_43_f1ef794e: 'Potential Student',
  auto_44_54c4176d: 'Students managed by Instructor',
  auto_45_307b3d02: 'Gold Coins',
  auto_174_4ca0c639: 'Instructor',
  auto_175_1e487d14: 'Please select Instructor',
  auto_176_e072ae03: 'Year',
  auto_177_549f4edc: 'Please select Year',
  auto_178_1451d388: 'Instructor',
  auto_179_a6fe13a2: 'Month',
  auto_180_cc0cd5d6: 'Total Score',
  auto_181_7b6ddcf5: 'Learning Duration',
  auto_182_70d25397: 'High Activity Level',
  auto_183_dd5a5f81: 'Learning Process Exceptions',
  auto_184_e239f301: 'Learning Trace',
  auto_185_3f249f0b: '3-Month Service Retention Rate',
  auto_248_97c154c8: 'Hantian Call System',
  auto_249_b42d7796: 'Hantian Call System',
  auto_250_17c33397: 'Yixun Call System',
  auto_251_c1c0bfb5: 'Yixun Call System',
  auto_252_0d9a129f: 'Hantian Call System',
  auto_253_9ed6b9e2: 'Hantian Call System',
  auto_254_1f305749: 'Yixun Call System',
  auto_255_6f18d813: 'Hantian Call System',
  auto_256_85a71b34: 'Yixun Call System',
  auto_257_2a712ab4: 'Hantian Call System',
  auto_258_e8ecdf89: 'Hantian Call System',
  auto_259_16891ae0: 'Hantian Call System',
  auto_260_c0643860: 'Yixun Call System',
  auto_261_43a2877f: 'Yixun Call System',
  auto_262_fc3c5be0: 'Hantian Call System',
  auto_263_60d9d1ff: 'Hantian Call System',
  auto_264_265e938b: 'Yixun Call System',
  auto_265_e642aeee: 'Hantian Call System',
  auto_266_240dd5d6: 'Yixun Call System',
  auto_267_009e35da: 'Hantian Call System',
  auto_200_cedb377d: 'Midterm Exam',
  auto_201_c72bfc09: 'Final Exam',
  auto_202_7a7919ce: 'Score Collection Rate',
  auto_203_621bd16f: 'Service Center Instructor (Self-Study Room + Online Only)',
  auto_204_4bd58f38: 'Valid Score Rate',
  auto_205_9cb80b2f: 'Students with recorded scores in the current major exam',
  auto_206_3ee43d9c: 'Exam Score Improvement Rate',
  auto_207_a12ebc3f: 'Numerator: Students whose current exam score is higher than the previous exam',
  auto_222_6d6d75ba: 'Midterm Exam',
  auto_223_2ccf65e2: 'Final Exam',
  auto_224_8d1511b9: 'Score Collection Rate',
  auto_225_ae854796: 'Among students managed by the Service Center Instructor (Self-Study Room + Online Only), the proportion of students with collected major exam scores',
  auto_226_6249da25: 'Valid Score Rate',
  auto_227_4c808c87: 'The proportion of students managed by Instructor with verified scores in the current major exam',
  auto_228_c1e58a43: 'Exam Score Improvement Rate',
  auto_229_b037e052: 'Numerator: Number of students managed by Instructor whose current exam score is higher than the previous exam. | Denominator: Number of students who submitted valid scores for two consecutive exams',
  auto_11_1f510f9d: 'Custom Role',
  auto_1_cc870123: 'Copy Invitation',
  auto_2_0fe929a0: 'Assign Permissions',
  auto_292_27cb13d9: 'Active',
  auto_13_103986be: 'Export',
  auto_14_3948439b: 'Export',
  auto_15_66896e7e: 'Export',
  auto_16_59bad31d: 'Export',
  auto_17_f2d02b17: 'Export Report',
  auto_18_4d93b56b: 'Export Report',
  auto_19_24b12701: 'Export Report',
  auto_20_84dbc023: 'Export Report',
  auto_21_a73ef1c9: 'Export',
  auto_22_e22d4af4: 'Export Report',
  auto_23_c83fd579: 'Export Report',
  auto_24_f20624c1: 'Export Report',
  auto_25_6ca8b5f2: 'Export Report',
  auto_26_1e9ac54b: 'Export Report',
  auto_27_b9cdcac3: 'Export Report',
  auto_28_7f6fac7f: 'Export Report',
  auto_29_46075933: 'Export Report',
  auto_30_74c980a5: 'Export Report',
  auto_31_4eb86c8d: 'Export Report',
  auto_32_34900b5f: 'Export Report',
  auto_7_b9f5df3b: 'Data Last Updated',
  auto_8_a16e1f4a: 'No Image',
  auto_281_3f293f12: 'Not Filled',
  auto_282_fc8617d3: 'Instructor (Not Checked In)',
  auto_268_ad79dcb5: 'Instructor',
  auto_269_179481a8: 'Please select Instructor',
  auto_270_be5d6edf: 'Month',
  auto_271_08422b87: 'Please select Month',
  auto_285_548986fa: 'Midterm Exam',
  auto_286_a09cfab4: 'Final Exam',
  auto_287_bacb05df: 'Subject',
  auto_288_a0ae573b: 'Please select Subject',
  auto_272_7849a449: 'Instructor',
  auto_273_016ee162: 'Please select Instructor',
  auto_274_866d6785: 'Month',
  auto_275_bb78fd4d: 'Please select Month',
  auto_276_cbfd49b4: 'Instructor',
  auto_277_0a55bb3c: 'Please select Instructor',
  auto_278_343826d3: 'Month',
  auto_279_6a7d3c7b: 'Please select Month',
  auto_289_35cc9d39: 'Instructor',
  auto_290_6b7066bf: 'Please select Instructor',
  auto_291_65a1cd2a: 'Service Retention Rate & High Activity Rate',
  auto_283_43133031: 'Completed',
  auto_284_56ca29d8: 'All',
  auto_244_74f9687b: 'Math',
  auto_245_2d033ec9: 'English',
  auto_246_b3637dcf: 'Physics',
  auto_247_1e45c663: 'Chemistry',
  auto_280_a644deaf: 'Single',
  auto_293_8396209e: 'Midterm Exam',
  auto_294_b254bd84: 'Final Exam',
  supervisorStatusFormat: 'Instructor Status: Self-Study Room ({selfStudy}), Online Only ({onlineOnly})',
  timeRangeOctNov: 'Oct–Nov',
  timeRangeAprMay: 'Apr–May',
  timeRangeJanFeb: 'Jan–Feb',
  timeRangeJunJul: 'Jun–Jul',
  dateFormatYMD: '{year}-{month}-{day}',
  exceptionSeveritySingle: 'Exception Triggered (Single Day/Week)',
  alarmTriggerCondition5: 'Triggered when 3 consecutive problems are answered with each response time < 1/3 of the average, and at least one answer is incorrect',
  alarmTriggerCondition6: 'Triggered when video watch time < 1/3 of total or not played, and subsequent problems are answered incorrectly',
  ordOne: '1',
  ordTwo: '2',
  ordThree: '3',
  ordFour: '4',
  ordFive: '5',
  ordSix: '6',
  ordSeven: '7',
  ordEight: '8',
  ordNine: '9',
  ordTen: '10',
  minuteUnit: 'min',
  secondUnit: 'sec',
  courseLevelUnit: 'Level',
  courseBatchUnit: 'Attempt',
  ordPrefix: 'No.',
  timesUnit: 'times',
  hasPrefix: ', with',
};
